import { render } from "./DataCollectionHistory.vue?vue&type=template&id=979412fe&scoped=true"
import script from "./DataCollectionHistory.vue?vue&type=script&lang=js"
export * from "./DataCollectionHistory.vue?vue&type=script&lang=js"

import "./DataCollectionHistory.vue?vue&type=style&index=0&id=979412fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979412fe"]])

export default __exports__